import axios from 'axios'
import { Swipe, SwipeItem, Toast } from "vant";
axios.defaults.timeout = 10000

// 开发时使用，解决跨域问题
axios.defaults.baseURL = 'https://api.feiyouyun.com/api/v1/';
// axios.defaults.baseURL = 'https://bapi.feiyouyun.com/api/';
// axios.defaults.baseURL = 'https://fy.vipkh.cn/api/';
// axios.defaults.baseURL = 'https://fymian.vipkh.cn/api/';


// http request 拦截器
axios.interceptors.request.use(
  config => {
    // const token ="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvZnkudmlwa2guY25cL2FwaVwvdjFcL2xvZ2luIiwiaWF0IjoxNTkyODEwNjQyLCJleHAiOjE1OTI5MDY2NDIsIm5iZiI6MTU5MjgxMDY0MiwianRpIjoiTU0xenFkYXFVV2RaMk1TaCIsInN1YiI6MTEsInBydiI6Ijg2NjVhZTk3NzVjZjI2ZjZiOGU0OTZmODZmYTUzNmQ2OGRkNzE4MTgifQ.khkgCBPyVPBpf15ke_a8fNvnz7mTerUfvwoEh1w9Iew";
    const token = window.localStorage.getItem('token')
    console.log(config)
    config.headers = {
      'Content-Type':'application/x-www-form-urlencoded'
    }
    if(token){
      config.headers.Authorization ='Bearer '+token
    }
    return config;
  },
  error => {
    console.log(JSON.parse(error))
    Toast(error.status)
    return Promise.reject(err);
  }
);


//http response 拦截器
axios.interceptors.response.use(
  response => {
    console.log(response.status)
    return response;
  },
  error => {
    console.log(JSON.parse(error))
    Toast(error.status)
    return Promise.reject(error)
  }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */




/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
 export function post(url, data = {}){
   return new Promise((resolve, reject) => {
     axios.post(url, data)
          .then(response => {
            resolve(response.data);
          }, err => {
            reject(err)
          })
   })
 }

 /**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, data = {}){
  return new Promise((resolve, reject) => {
    axios.get(url, data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}

 /**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */




// WEBPACK FOOTER //
// ./src/http.js